import { Autocomplete, Chip, TextField } from "@mui/material";
import React from "react";

const multiSelectFieldSx = {
  "& .MuiOutlinedInput-root": {
    fontSize: { xs: "16px", sm: "16px" },
    minHeight: { xs: "56px", sm: "56px" },
  },
  "& .MuiInputLabel-root": {
    fontSize: { xs: "16px", sm: "16px" },
  },
};

const MultiSelectAutocomplete = ({
  label,
  placeholder,
  options,
  value,
  onChange,
  getOptionLabel,
  getOptionValue,
  disabled,
  isRTL,
}) => (
  <Autocomplete
    multiple
    fullWidth
    disabled={disabled}
    options={options}
    value={options.filter((option) => value.includes(getOptionValue(option)))}
    onChange={(_, newValue) => onChange(newValue.map(getOptionValue))}
    getOptionLabel={getOptionLabel}
    isOptionEqualToValue={(option, selected) =>
      getOptionValue(option) === getOptionValue(selected)
    }
    filterOptions={(opts, { inputValue }) => {
      if (!inputValue) {
        return opts.slice(0, 50);
      }
      const filter = inputValue.toLowerCase();
      return opts.filter((option) =>
        getOptionLabel(option).toLowerCase().includes(filter)
      );
    }}
    noOptionsText="لا توجد نتائج"
    loadingText="جاري البحث..."
    renderTags={(tagValue, getTagProps) =>
      tagValue.map((option, index) => (
        <Chip
          {...getTagProps({ index })}
          key={getOptionValue(option)}
          label={getOptionLabel(option)}
          size="small"
        />
      ))
    }
    renderInput={(params) => (
      <TextField
        {...params}
        label={label}
        placeholder={placeholder}
        sx={multiSelectFieldSx}
      />
    )}
    ListboxProps={{
      style: {
        maxHeight: "300px",
      },
    }}
    dir={isRTL ? "rtl" : "ltr"}
  />
);

export default MultiSelectAutocomplete;
